<template>
   <div class="main__select" >
       <label v-if="label" :style="disabled ? 'color:gray;' : null">{{label}}<PopOver v-if="hasPopOver" v-bind="popOver"/></label>
        <!-- <select v-if="singleSelect" ref="select" @change="select($event)" :style="selectStyle"  :disabled="disabled"> 
            <option v-if="placeholder && !selected" value="" disabled selected>{{placeholder}}</option>
            <option v-for="(option, index) in options" :key="index" :value="option.id ? option.id : option" :selected="option.name && option.name == selected || option == selected">{{option.name ? option.name : option}}</option>
        </select> -->
        <div class="multi__select" >
            <div class="selected_option" @click.self="showOptions = disabled ? false :  !showOptions" :class="{focused:showOptions,disabled:disabled}">
                <div  v-if="!singleSelect && optionsSelected && optionsSelected.length > 0">
                    <div class="option" v-for="(option,index) in optionsSelected" :key="index">
                        <span>{{option.name ? option.name : option}}</span>
                        <span @click="removeOption(option)" class="remove"><i class="fas fa-times"></i></span>
                    </div>
                </div>
                <div v-else-if="singleSelect && optionsSelected" class="single_option">
                    <img v-if ="hasImage && optionsSelected.image && optionsSelected.image.imageURL" :src="optionsSelected.image.imageURL" alt="" srcset="">
                    <span>{{optionsSelected.name ? optionsSelected.name : optionsSelected}}</span>
                </div>
                <span v-else>{{placeholder}}</span>
                <span v-if="showOptions && !disabled" class="drop_down_arrow" @click="showOptions = !showOptions"><i class="fas fa-angle-up"></i></span>
                <span v-else class="drop_down_arrow" @click="showOptions = !showOptions"><i class="fas fa-angle-down"></i></span>
            </div>
            <ul v-if="showOptions">
                <li v-for="(option,index) in optionsList" :key="index" @mousedown.self="setSelectedOption(option)" @mouseenter="setHoverOption(option)" @mouseleave="setHoverOption(null) " :class="{selected: !option.name && optionsSelected.includes(option)}" >
                    <img v-if ="hasImage && option.image && option.image.imageURL" :src="option.image.imageURL" alt="" srcset="">
                    {{option.name ? option.name : option}} <Icon v-if="option.icon" :icon="option.icon"/>
                     <ul v-if="option.childrens && hoveredOption == option.name" class="childrens__option">
                        <li v-for="(item,index) in option.childrens" :key="index"  @mousedown="setSelectedOption(item)" :class="{selected:optionsSelected.includes(item)}" >{{item}}</li>
                    </ul>
                </li>
            </ul>
        </div>
   </div>
</template>

<script>
import Icon from './Icon.vue'
import PopOver from './Popover.vue'

export default {
    components : { Icon, PopOver },
    props : { 
        options : { type: Array,},
        placeholder : { type: String, default : "Select your option"},
        label : { type : String, default : null},
        width : { type : String, default : null},
        singleSelect : { type : Boolean, default : true},
        height  :{ type : Number, default : 2.3},
        disabled  :{ type : Boolean, default : false},
        margin  :{ type : Number, default : 2},
        padding : { type : Object, default : () => ({x : .7, y: .3})},
        selected : { type : [String, Number ,Boolean, Object, Array]},
        hasPopOver : { type: Boolean, default: false},
        popOver : { type:Object, default :null},
        returnType : { type : String, default: 'name'},
        hasImage : { type: Boolean, default: false},
        withDefaultVal : { type : Boolean, default : true}

    },
    mounted(){
        if(this.withDefaultVal){
            this.$emit('input',this.selectedValue)
            if(this.singleSelect) this.optionsSelected = this.selectedValue;
            else this.optionsSelected = []
        } 
    },
    data(){
        return {
            optionsSelected : null,
            hoveredOption : null,
            showOptions : false,
        }
    },
    computed  :{ 
        selectedValue(){
            console.log("option",this.optionsList);
            if(this.selected == undefined) return this.optionsList && this.optionsList.length > 0 ?  this.optionsList[0] && this.optionsList[0].name && this.returnType == 'name' ? this.optionsList[0].name : this.optionsList[0] : ''
            else return this.selected;
        },
        selectStyle(){
            return {
                // width : this.width ? this.width : '100%',
                hieght : this.hieght+'rem',
                margin : this.margin+'rem',
                padding : `${this.padding.y}rem ${this.padding.x}rem`
            }
        },
        optionsList(){return this.options}
    },
    watch : { 
        optionsSelected(selectedOption){
            this.$emit('input',selectedOption)
        },
        optionsList(val){
            console.log(val);
            this.optionsSelected = val && val.length > 0 ? val[0].name ? val[0].name : val[0] : null
        }
    },
    methods : {
        // select(e) {
        //     let selectedItem = this.options.find(item => item.id == e.target.value)
        //     if( selectedItem && selectedItem.name) this.$emit('input',selectedItem.name)
        //     else  this.$emit('input',e.target.value)
        // },
        setSelectedOption(option) {
            let op = option.name ? option.name : option
            if(!option.childrens && !this.singleSelect && this.optionsSelected && !this.optionsSelected.includes(op))this.optionsSelected.push(op);
            else if(!option.childrens && this.singleSelect) this.optionsSelected = this.returnType != 'name' ? option : op;
                this.showOptions = false
                this.hoveredOption = null
        },
        setHoverOption(option) {
            if(option && option.name)this.hoveredOption = option.name
            else this.hoveredOption = option
        },
        removeOption(option){
            this.optionsSelected.splice( this.optionsSelected.indexOf(option),1)
            }
    }
}
</script>

<style lang="scss" scoped>
    .main__select {
        display : flex;
        flex-direction : column;
        position: relative;
        margin : .5rem 0;
       
    }
    select {
        border: 1px solid rgb(209, 209, 209);
        font-size: .9rem;
        border-radius: .3rem;
        -webkit-appearance: auto;
        width : 100%;
        &:focus {
            outline : none;
            box-shadow:none;
        }
        &::placeholder {
            color : rgb(165, 165, 165);
        }
    }
    option {
        padding : 1rem;
        position : relative;
    }
    .single_option {
        padding : 0 .5rem;
        img {
            width: 2rem;
            height: 2rem;
            border-radius: 0.2rem;
            object-fit: cover;
            margin-right: .5rem;
        }
        span {
            max-width: 100% ;
            overflow: hidden;
            white-space: nowrap;
        }
    }
    .multi__select {
        position : relative;
        border-radius: 0.2rem;
        // &:focus {
        //     box-shadow: 0 0 0px 2px #1979e7;

        // }
    }
    label {
        display:flex;
    }
    .selected_option {
        box-shadow: 0 0 1px black;
        width : 100%;
        padding : .4rem .8rem;
        border-radius: .3rem;
        display:flex;
        justify-content:space-between;
        align-items: center;
        // flex-wrap: wrap;
        position: relative;
        div:first-child {
            display:flex;
            flex-wrap: wrap;
        }
        .option {
            display:flex;
            align-items: center;
            background-color : #7367f0;
            color : #ffffff;
            width : fit-content;
            padding : .2rem .5rem;
            margin : .2rem;
            font-weight: 400;
            border-radius: .3rem;
        }
    }
    ul {
        position : absolute;
        left:0;
        z-index: 99;
        width : 100%;
        background-color:#ffffff;
        // box-shadow: 0 0 1px black;
        box-shadow: 0 4px 24px 0 #22292f1a;
        margin : 0.4rem 0;
        padding : 0;
        border-radius: .3rem;
        max-height: 12rem;
        overflow-y: scroll;
        overflow-x: hidden;
        li {
            position:relative;
            list-style: none;
            padding : .3rem .8rem;
            &:hover {
                background-color: #7267f036;
                color: #7367f0;
                cursor: pointer;
            }
            img {
                width: 2rem;
                height: 2rem;
                border-radius: 0.2rem;
                object-fit: cover;
                margin-right: .5rem;
            }
        }


    }
    .childrens__option {
        left : 16rem;
        top: -0.5rem;
    }
    .disabled {
        background-color: #f1f1f1;
        color: #918d8d;
    }
    .selected {
        background-color: #7367f0;
        color: #ffffff;
    }
    .focused {
        box-shadow: 0 0 2px #7367f0;
    }
    .remove {
        padding : .2rem .3rem;
        cursor: pointer;
    }
    .drop_down_arrow {
        cursor: pointer;
    }
    /* width */
    ::-webkit-scrollbar {
    width: 5px;
    border-radius: .5rem;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: #f1f1f1; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: #d8d8d8; 
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: #555; 
    }
</style>


// WEBPACK FOOTER //
// src/components/global/Select.vue